import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';
import { IBlog } from '../blogs/blog';
import { BlogService } from '../blogs/blog.service';
import { BlogType } from './blogtypes';
declare var $: any;
@Component({
  templateUrl: "./myfleetsolutions.component.html"
})
export class MyFleetSolutionsComponent implements OnInit, AfterViewInit {
  public pageTitle: string = 'My Fleet Solutions';
  blogsList: IBlog[];
  category: string;
  constructor(private authService: AuthService,
    private appCommonService: AppCommonService,
    public blogService: BlogService,
  ) {
    this.appCommonService.pageContentAdditionalClass = "home-page main-page";
    this.appCommonService.pageName = this.pageTitle;
  }
  ngOnInit() {
    this.category = BlogType.myfleetsolutions;
    this.loadBlogsList();
    window.scrollTo(0, 0);
  }

  ngAfterViewInit() {
    this.appCommonService.loadRequiredJS();
    $('.tabs-left li a').hover(function () {      
      $(this).trigger('click');
    });
    $('.sliderformobile').bxSlider({
      auto: true,
      pager: true,
      controls: false,
      touchEnabled: true,
      adaptiveHeight: true
    });

    $('#mfs_video').on('show.bs.modal', function (e) {
      $("#video1").attr('src', "https://www.youtube.com/embed/rTAVH3DxG4o?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
    });
    $('#mfs_video').on('hide.bs.modal', function (e) {
      $("#video1").attr('src', "https://www.youtube.com/embed/rTAVH3DxG4o");
    });

    $('#mileage_video').on('show.bs.modal', function (e) {
      $("#video2").attr('src', "https://www.youtube.com/embed/Q6Vi0i7OBR0?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
    });
    $('#mileage_video').on('hide.bs.modal', function (e) {
      $("#video2").attr('src', "https://www.youtube.com/embed/Q6Vi0i7OBR0");
    });

    $('#fleet_video').on('show.bs.modal', function (e) {
      $("#video3").attr('src', "https://www.youtube.com/embed/rnG2CKNlTds?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
    });
    $('#fleet_video').on('hide.bs.modal', function (e) {
      $("#video3").attr('src', "https://www.youtube.com/embed/rnG2CKNlTds");
    });

    $('#mfsexpert_video').on('show.bs.modal', function (e) {
      $("#video4").attr('src', "https://www.youtube.com/embed/9dsVAFMWCeg?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
    });
    $('#mfsexpert_video').on('hide.bs.modal', function (e) {
      $("#video4").attr('src', "https://www.youtube.com/embed/9dsVAFMWCeg");
    });	
  }

  loadBlogsList() {
    this.blogService.getBlogsList(this.category)
      .subscribe(
      (blogs: IBlog[]) => {
        this.blogsList = blogs;
      },
      (error: any) => {
        this.blogService.showError("Blog retrieval problem", <any>error)
      }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/genericpages/myfleetsolutions.component.ts